<template lang="pug">
  .root
    div(class="header-content")
      div(class="header-border")
      a(@click="$router.push({ name: 'TopIndex' })" class="header-logo") 
        img(src="/img/logo.png")
      div(class="header-border")
</template>

<style src="./header.scss" lang="scss" scoped>
</style>

<script>

export default {
  name: "ComponentsHeaderIndex",
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    async onLogout() {
      await this.$store.dispatch('user/logout');
      this.$router.push({ name: 'LoginIndex' });
    },
  }
}
</script>